import type { User } from '@videoblocks/user-service-client';

export enum CreateUserOutcome {
    UserCreated = 'UserCreated',
    UserAlreadyRegistered = 'UserAlreadyRegistered',
    Error = 'Error',
}

export type CreateUserResultUserCreated = {
    outcome: CreateUserOutcome.UserCreated;
    user: User;
};

export type CreateUserResultUserAlreadyRegistered = {
    outcome: CreateUserOutcome.UserAlreadyRegistered;
}

export type CreateUserResultError = {
    outcome: CreateUserOutcome.Error;
    error: string;
};

export type CreateUserResult =
    | CreateUserResultUserCreated
    | CreateUserResultUserAlreadyRegistered
    | CreateUserResultError;